// #

import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { TJob } from 'redux/reducers/classifications/types';

// export type TClassifications = {
// 	id: number;
// 	type: string;
// 	startedAt: string;
// 	finishedAt: string;
// 	state: string;
// };
export const tableStructure: TTableStructure<keyof TJob>[] = [
	{
		name: 'Id',
		selector: 'id' as keyof TJob,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Type',
		selector: 'type' as keyof TJob,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Started At',
		selector: 'startedAt' as keyof TJob,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Finished At',
		selector: 'finishedAt' as keyof TJob,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'State',
		selector: 'state' as keyof TJob,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colors: [
			['Finished', 'success.light'],
			['Running', 'info.light'],
		],
	},
];
